<template>
    <div class="bg " :style="{
        'background': `url(${config.bgImageUrl}) no-repeat center/cover`,
        'backgroundColor': '#f5f5f5' // 添加备用背景色
    }">

        <div>
            <div>
                <img class="logo" :src="config.logoTopImg" alt="" :style="{ 'height': config.logoTopHeight + 'px' }">
                <img v-if="$i18n.locale == 'en'" src="../assets/img/progress.png" alt="" class="jindu">
                <img v-else src="../assets/img/progress_cn.png" alt="" class="jindu" />
            </div>
            <div class="tishi_wrap">
                <div class="content_title">
                    <img src="../assets/img/dui.png" alt="" class="dui">
                </div>
                <div class="content_con">
                    <p style="margin-bottom:1.25rem;font-weight:bold">{{ $t('Congratulations') }}</p>
                    <!-- <span class="xian"></span> -->
                </div>
            </div>
            <div class="img_wrap">
                <img src="../assets/img/wei1.png" alt=""
                    v-if="certificateDetail.operationName == 'Digital Life Design 2022'">
                <img src="../assets/img/wei2.png" alt="" v-else>
                <span class="span">
                    <div style="font-weight:bold;margin-bottom:.3125rem">{{ certificateDetail.nickName ?
                        certificateDetail.nickName : ''}}</div>
                    <span style="font-size:.75rem">
                        {{ certificateDetail.description ? certificateDetail.description : '' }}
                    </span>
                </span>

            </div>
            <div class="more" style="margin-bottom:1.25rem">
                <div class="content_con">
                    <p style="font-size:.8125rem">{{ $t('TheNFTdisplayed') }}</p>
                </div>
            </div>
            <div class="content m_rl_20">
                <ul class="lists">
                    <li>
                        <div>{{ $t('NFTName') }}</div>
                        <div>{{ $t('CarbonNeutralFor') }}
                            <!-- {{certificateDetail.operationName}} -->
                            {{ $t('OCBCPublicSectorDay') }}
                        </div>
                    </li>
                    <li>
                        <div>{{ $t('TransactionHash') }}</div>
                        <div>
                            <a :href="certificateDetail.nftContractUrl">
                                <!-- {{certificateDetail.nftTransactionHash}} -->
                                0x3931e7834d46b5e8a3e19e0096d3c906480e55ff2b5be339d2800799ebdfabe1
                            </a>
                        </div>
                    </li>
                    <li>
                        <div>{{ $t('TokenID') }}</div>
                        <div>{{ sn }}</div>
                    </li>
                </ul>
            </div>
            <!-- <div class="content m_rl_20">
            <div class="title">
                Personalized Message
            </div>
            <div class="Personalised_con">{{certificateDetail.description ? certificateDetail.description : ''}}</div>
        </div> -->
            <div class="more">
                <div class="content_con">
                    <p style="font-size:.8125rem">{{ $t('Moredetailshavebeensent') }}</p>
                    <span class="xian"></span>
                </div>
            </div>
            <div class=" please">
                <!-- Please visit 
            <a href="https://www.mvgx.com/">https://www.mvgx.com/ </a>
            for more information about our products  -->
            </div>
        </div>
    </div>
</template>
<script>
import cnt from '@/api/cnt.js'
export default {
    data() {
        return {
            sn: '',
            certificateDetail: {},
            config: '',
        }
    },
    created() {
        this.sn = this.$route.query.sn;
        this.config = JSON.parse(sessionStorage.getItem('configData')) || ''
    },
    mounted() {
        this.sn = this.$route.query.sn
        this.config = JSON.parse(sessionStorage.getItem('configData')) || ''
        this.getTravelRecord()
    },
    methods: {
        getTravelRecord() {
            cnt.getTravelRecord(
                (res) => {
                    console.log(res)
                    this.certificateDetail = res;
                },
                { sn: this.sn }
            );
        },
    }
}
</script>
<style lang="less" scoped>
.jindu {
    width: 20.8438rem;
    height: 2.5938rem;
    position: absolute;
    top: 5.2rem;
    // left: 1.2813rem;
    left: 50%;
    transform: translate(-50%, 0);
}

a {
    color: #ffffff;
    text-decoration: none;
}

.bg {
    width: 100%;
    min-height: 100%;
    background-repeat: no-repeat;
    background-size: 100% 100%;
}

.logo {
    width: auto;
    position: absolute;
    top: 1.5rem;
    left: 1.25rem;
}

.content {
    background-color: rgba(255, 255, 255, 0.13);
    backdrop-filter: blur(.3125rem);
    padding-bottom: 1.75rem;
    // text-align: center;
    color: #fff;
    border-radius: 1.25rem;
    margin-bottom: 1.6875rem;

    .title {
        font-size: 1rem;
        margin: 0 1.5rem;
        padding: 1.5rem 0;
        font-weight: bold;
        color: #ffffff;
        border-bottom: .0625rem solid rgba(255, 255, 255, 0.5);
    }

    .Personalised_con {
        margin: 0 1.5rem;
        padding-top: 1.3125rem;
        color: #ffffff;
        font-size: .9375rem;
        white-space: normal;
        word-break: break-all;
    }

    .lists {
        margin: 0 1.25rem;

        li {
            list-style: none;
            padding: 1.25rem 0;
            border-bottom: .0625rem solid rgba(255, 255, 255, 0.5);
            font-size: .9375rem;
            font-family: Century Gothic;

            div {
                font-size: .75rem;
                margin-bottom: 1.1875rem;
            }

            :last-child {
                margin: 0;
                white-space: normal;
                word-break: break-all;
            }
        }
    }
}

.dui {
    width: 2.6875rem;
    height: 1.875rem;
    margin-bottom: 2.0625rem;

}

.content_con {
    margin: 0 1.25rem;
    font-size: .9375rem;
    font-family: Century Gothic;
}

.xian {
    display: inline-block;
    width: 2.1875rem;
    opacity: 0.45;
    /* background-color: pink; */
    border-radius: 1.25rem;
    border-bottom: .3125rem solid #FFFFFF;
    /* margin-bottom: 2.3125rem; */
}

.please {
    padding: 1.6875rem 1.25rem 7.25rem;
    font-size: .8125rem;
    font-family: Century Gothic;
    color: #FFFFFF;
    text-align: center;

}

.please>span {
    font-weight: bold;
}

.btn {
    width: 100%;
    height: 2.8125rem;
    color: #4D94A0;
    margin-bottom: 1.3125rem;
    border-radius: .625rem;
    font-size: .9375rem;
    font-family: Century Gothic;
    box-shadow: 0px 5px 12px 0px rgba(0, 98, 76, 0.22);
}

.tishi_wrap {
    padding-top: 9rem;
    text-align: center;
    font-size: 1rem;
    font-family: Century Gothic;
    color: #FFFFFF;
    font-weight: bold;
}

.more {
    text-align: center;
    font-size: .8125rem;
    color: #ffffff;
    font-family: Century Gothic;

}

.img_wrap {
    display: flex;
    justify-content: center;
    margin-bottom: 1.875rem;
    position: relative;

    img {
        width: 14.375rem;
        height: 14.375rem;
    }

    .span {
        display: inline-block;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        font-size: .625rem;
        // font-size: .1875rem;
        width: 22%;
        text-align: center;

    }

    .more1 {
        display: inline-block;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        font-size: .1875rem;
        width: 22%;
        text-align: center;

    }
}
</style>
